import { render, staticRenderFns } from "./column-brutto.vue?vue&type=template&id=69dd294c&"
import script from "./column-brutto.vue?vue&type=script&lang=js&"
export * from "./column-brutto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports